import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://tribaltech-backend.onrender.com';

export default function VaultDirectLanding() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [creators, setCreators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/storefront/browse`)
      .then(r => setCreators(r.data.creators || []))
      .catch(e => setErr(e.response?.data?.error || e.message))
      .finally(() => setLoading(false));
  }, []);

  function submitSearch(e) {
    e.preventDefault();
    const clean = query.trim().replace(/^@/, '');
    if (!clean) return;
    navigate(`/${encodeURIComponent(clean)}`);
  }

  const filtered = query.trim()
    ? creators.filter(c => c.username.toLowerCase().includes(query.trim().toLowerCase().replace(/^@/, '')))
    : creators;

  return (
    <div style={page}>
      <header style={headerStyle}>
        <div style={{ display:'flex', alignItems:'center', gap: 10 }}>
          <div style={logoMark}>V</div>
          <div style={{ color:'#fff', fontWeight: 600, fontSize: 16, letterSpacing: 0.5 }}>
            MyVault <span style={{ color:'#a78bfa', fontWeight: 400 }}>· vaultdirect.io</span>
          </div>
        </div>
        <div>
          <Link to="/vault/login" style={headerLink}>Buyer sign in</Link>
        </div>
      </header>

      <section style={heroSection}>
        <div style={eyebrow}>MyVault marketplace</div>
        <h1 style={heroTitle}>Support your creators, watch their exclusive content.</h1>
        <p style={heroSub}>
          One-time purchase, no subscription, no reselling. Per-buyer watermarking coming soon.
        </p>

        <form onSubmit={submitSearch} style={searchForm}>
          <span style={searchPrefix}>@</span>
          <input
            type="text"
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Creator username"
            style={searchInput}
          />
          <button type="submit" style={searchButton} disabled={!query.trim()}>Go</button>
        </form>
        <div style={{ color:'#666', fontSize: 12, marginTop: 8 }}>
          or browse below — updated as new creators publish
        </div>
      </section>

      <section style={{ maxWidth: 1100, margin: '0 auto', padding:'0 20px 80px' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom: 20 }}>
          <div style={sectionTitle}>
            {query.trim() ? `Matching "${query.trim()}"` : 'Browse creators'}
          </div>
          <div style={{ color:'#666', fontSize: 12 }}>
            {filtered.length} {filtered.length === 1 ? 'creator' : 'creators'}
          </div>
        </div>

        {loading && <div style={{ color:'#666' }}>Loading…</div>}
        {err && <div style={{ color:'#f87171' }}>{err}</div>}
        {!loading && !err && filtered.length === 0 && (
          <div style={emptyBox}>
            {query.trim()
              ? <>No match for "{query.trim()}". <span style={{ color:'#a78bfa', cursor:'pointer' }} onClick={submitSearch}>Visit that page anyway →</span></>
              : 'No creators with published videos yet.'}
          </div>
        )}

        <div style={grid}>
          {filtered.map(c => (
            <Link to={`/${encodeURIComponent(c.username)}`} key={c.username} style={{ textDecoration:'none' }}>
              <div style={creatorCard}>
                <div style={cardThumb}>
                  {c.sample_preview_url ? (
                    <video src={c.sample_preview_url} muted playsInline preload="metadata"
                           style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
                  ) : (
                    <div style={{ color:'#444', fontSize: 32, display:'flex', alignItems:'center', justifyContent:'center', height:'100%' }}>
                      @
                    </div>
                  )}
                </div>
                <div style={{ padding: 14 }}>
                  <div style={{ color:'#fff', fontSize: 15, fontWeight: 600 }}>@{c.username}</div>
                  <div style={{ color:'#94a3b8', fontSize: 12, marginTop: 2 }}>
                    {c.listing_count} {c.listing_count === 1 ? 'video' : 'videos'}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <footer style={footerStyle}>
        <div>MyVault · powered by Creator Protect</div>
        <div style={{ display:'flex', gap: 18 }}>
          <Link to="/vault/login" style={footerLink}>Buyer sign in</Link>
          <a href="https://creatorprotect.io" style={footerLink}>Creators → list your content</a>
        </div>
      </footer>
    </div>
  );
}

const page = {
  minHeight: '100vh',
  background: 'linear-gradient(180deg, #0f0f1e 0%, #0a0a0f 100%)',
  color: '#f0ede8',
  fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};
const headerStyle = {
  maxWidth: 1100, margin: '0 auto',
  padding: '20px 20px',
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
};
const logoMark = {
  width: 32, height: 32, borderRadius: 8,
  background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
  color: '#fff', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontSize: 16,
};
const headerLink = { color: '#a78bfa', textDecoration: 'none', fontSize: 13 };

const heroSection = {
  maxWidth: 760, margin: '0 auto',
  padding: '60px 20px 50px', textAlign: 'center',
};
const eyebrow = {
  fontSize: 11, color: '#a78bfa', letterSpacing: 3, textTransform: 'uppercase',
  marginBottom: 18,
};
const heroTitle = {
  fontSize: 44, fontWeight: 600, lineHeight: 1.1, color: '#fff',
  margin: '0 0 18px',
};
const heroSub = {
  fontSize: 17, color: '#94a3b8', lineHeight: 1.55, maxWidth: 560, margin: '0 auto 32px',
};
const searchForm = {
  display: 'flex', alignItems: 'center', gap: 8,
  maxWidth: 440, margin: '0 auto',
  background: '#111', border: '1px solid #222', borderRadius: 12,
  padding: 6, position: 'relative',
};
const searchPrefix = {
  color: '#555', fontSize: 18, paddingLeft: 12,
};
const searchInput = {
  flex: 1, background: 'transparent', border: 'none', color: '#fff',
  fontSize: 15, padding: '10px 4px', outline: 'none', fontFamily: 'inherit',
};
const searchButton = {
  background: '#7c3aed', color: '#fff', border: 'none',
  padding: '10px 20px', borderRadius: 8, fontWeight: 600, fontSize: 14,
  cursor: 'pointer',
};

const sectionTitle = {
  fontSize: 20, fontWeight: 600, color: '#fff',
};
const grid = {
  display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16,
};
const creatorCard = {
  background: '#111', borderRadius: 12, border: '1px solid #222', overflow: 'hidden',
  cursor: 'pointer',
};
const cardThumb = { aspectRatio: '16/9', background: '#0a0a0a' };
const emptyBox = {
  background: '#111', borderRadius: 12, border: '1px solid #222',
  padding: 40, color: '#94a3b8', textAlign: 'center', lineHeight: 1.6,
};
const footerStyle = {
  maxWidth: 1100, margin: '40px auto 0', padding: '24px 20px',
  borderTop: '1px solid #1a1a1a',
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  color: '#555', fontSize: 12,
};
const footerLink = { color: '#888', textDecoration: 'none' };
